import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
  const authStore = useAuthStore()
  const { $msal } = useNuxtApp()

  authStore.setAuthToken(undefined)
  $msal.clearCache()
})
